import loadable from '@loadable/component'

export default [
  {
    // 用户协议
    path: '/static/userAgreement',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-userAgreement" */ '~/pages/StaticPage/UserAgreement'
        )
    ),
  },
  {
    // 隐私协议
    path: '/static/privacyAgreement',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-PrivacyAgreement" */ '~/pages/StaticPage/PrivacyAgreement'
        )
    ),
  },
  {
    // 知识产权
    path: '/static/intellectualProperty',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-IntellectualProperty" */ '~/pages/StaticPage/IntellectualProperty'
        )
    ),
  },
  {
    // 版权保护说明
    path: '/static/copyrightProtection',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-CopyrightProtection" */ '~/pages/StaticPage/CopyrightProtection'
        )
    ),
  },
  {
    // 曲库使用说明
    path: '/static/musicLibrary',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-MusicLibrary" */ '~/pages/StaticPage/MusicLibrary'
        )
    ),
  },
  {
    // 社区规范
    path: '/static/communityGuidelines',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-CommunityGuidelines" */ '~/pages/StaticPage/CommunityGuidelines'
        )
    ),
  },
  {
    // 开源软件
    path: '/static/openSource',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-OpenSource" */ '~/pages/StaticPage/OpenSource'
        )
    ),
  },
  {
    // 社区公约
    path: '/static/higoCommunityNorms',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-higoCommunityNorms" */ '~/pages/StaticPage/higoCommunityNorms'
        )
    ),
  },

  {
    // 关于我们
    path: '/static/aboutUs',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-aboutUs" */ '~/pages/StaticPage/AboutUs'
        )
    ),
  },
  {
    // 联系我们
    path: '/static/contactUs',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-contactUs" */ '~/pages/StaticPage/ContactUs'
        )
    ),
  },
  {
    // 退款协议
    path: '/static/policy',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-static-ReturnPolicy" */ '~/pages/StaticPage/ReturnPolicy'
        )
    ),
  },
]
